function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M152,272c-52.9,0-96,43.1-96,96s43.1,96,96,96s96-43.1,96-96S204.9,272,152,272z M232,368c0,11.7-2.6,22.8-7.1,32.8 l-42.2-24.3c0.8-2.7,1.3-5.5,1.3-8.5s-0.5-5.8-1.3-8.5l42.2-24.3C229.4,345.2,232,356.3,232,368z M216.8,321.3l-42,24.3 c-4-4.1-9.1-7-14.8-8.5v-48.7C183.4,290.7,203.8,303.2,216.8,321.3z M152,384c-8.8,0-16-7.2-16-16s7.2-16,16-16s16,7.2,16,16 S160.8,384,152,384z M144,288.4v48.7c-5.7,1.5-10.8,4.4-14.8,8.5l-42-24.3C100.2,303.2,120.6,290.7,144,288.4z M72,368 c0-11.7,2.6-22.8,7.1-32.8l42.2,24.3c-0.8,2.7-1.3,5.5-1.3,8.5s0.5,5.8,1.3,8.5l-42.2,24.3C74.6,390.8,72,379.7,72,368z M87.2,414.7 l42-24.3c4,4.1,9.1,7,14.8,8.5v48.7C120.6,445.3,100.2,432.8,87.2,414.7z M160,447.6v-48.7c5.7-1.5,10.8-4.4,14.8-8.5l42,24.3 C203.8,432.8,183.4,445.3,160,447.6z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384,384h-57.2l-13.3-80H336c13.2,0,24-10.8,24-24v-16c0-13.2-10.8-24-24-24H168.2l-24.3-121.4L134.8,64H32 C14.4,64,0,78.4,0,96s14.4,32,32,32h49.4l24.2,120.8C57.9,267.5,24,313.8,24,368c0,70.6,57.4,128,128,128 c51.9,0,96.6-31.1,116.6-75.5l1.2,7.5c1.9,11.6,11.9,20,23.7,20H384c13.2,0,24-10.8,24-24v-16C408,394.8,397.2,384,384,384z  M344,264v16c0,4.4-3.6,8-8,8h-84.2c-10.4-13-23.3-23.9-37.9-32H336C340.4,256,344,259.6,344,264z M16,96c0-8.8,7.2-16,16-16h89.2 l5.3,32H32C23.2,112,16,104.8,16,96z M97.8,128h31.7l22.4,112c-10.7,0-21,1.5-30.9,4L97.8,128z M152,480c-61.8,0-112-50.2-112-112 s50.2-112,112-112s112,50.2,112,112S213.8,480,152,480z M392,424c0,4.4-3.6,8-8,8h-90.4c-3.9,0-7.2-2.8-7.9-6.7l-6.8-41 c0.7-5.4,1.2-10.8,1.2-16.4c0-23.3-6.4-45.1-17.3-64h34.5l16,96H384c4.4,0,8,3.6,8,8V424z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M395,4c-27.4,0-52.1,11.6-69.6,30.1c-0.1,0.1-0.3,0.1-0.4,0.3c-0.2,0.2-0.3,0.4-0.4,0.6C308.8,52.1,299,74.9,299,100 c0,52.9,43.1,96,96,96c52.9,0,96-43.1,96-96C491,47.1,447.9,4,395,4z M314.5,100c0-18.3,6.2-35.2,16.6-48.7L443.7,164 c-13.5,10.3-30.4,16.6-48.7,16.6C350.6,180.5,314.5,144.4,314.5,100z M455.1,153.4L341.6,39.9c14.2-12.7,32.9-20.5,53.4-20.5 c44.4,0,80.5,36.1,80.5,80.5C475.5,120.5,467.7,139.2,455.1,153.4z"
})));

var SvgNoA11Y = function SvgNoA11Y(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoA11Y, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-a11y.ff649cdc.svg";
export { ForwardRef as ReactComponent };